import React from 'react';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';

import AccountStatus from 'src/components/Account/Status';
import { Loading } from 'src/components/DataState';
import { upcomingSale } from 'src/utils/upcomingSale';
import PageHeader from '../Headers/PageHeader';
import SaleCard from './SaleCard';

import { SALES } from './queries';
import spacing from 'src/styles/spacing';

const SalesContainer = styled.div`
  padding: ${spacing.elementGap} ${spacing.pageGutter};
`;

const SaleGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing.elementGap};
  margin-bottom: 50px;
`;

const Sales = ({homeIndex}) => {
  const { data } = useQuery(SALES);

  if (!data) { return <Loading />; }

  const upcoming = data.sales.filter(sale => upcomingSale(sale));

  return (
    <>
      <PageHeader title="Upcoming Auctions" />
      <SalesContainer>
          {!homeIndex &&
            <AccountStatus />
          }
          <SaleGrid>
            {upcoming.map(sale => (
              <SaleCard key={sale.id} sale={sale} large />
            ))}
          </SaleGrid>
      </SalesContainer>
    </>
  );
};

export default Sales;
